"use strict";

/* global Waypoint */

import "core-js/stable";
import "regenerator-runtime/runtime";
import "sortable/js/sortable";
import Preloader from "./util/preloader";
import AirbrakeClient from "airbrake-js";
import { isRecaptchaAirbrakeNoise } from "./util/is_recaptcha_airbrake_noise.mjs";
require("es6-promise/auto");
require("isomorphic-fetch");
// bootstrap-sass (the BS3 safety net) is REMOVED — every $.fn.* call site + data-* markup attr
// is reconciled to BS5. Removing it flips the jQuery plugin bridge from
// bootstrap-sass(BS3) to BS5: BS5's bundle auto-registers $.fn.modal/.tooltip/.popover/.collapse
// when window.jQuery is present, so the BS5-facing JS edits (dispose, .in→.show, _initializeFocusTrap)
// go live here. The bootstrap-sass npm package + its SCSS (_custom_bootstrap.scss) stay until the
// admin sb-admin chrome is re-flattened against BS5 (a deferred follow-up).
import * as bootstrapBundle from "bootstrap/dist/js/bootstrap.bundle.js"; // Bootstrap 5 vanilla API (UMD bundle, popper embedded)
window.bootstrap = bootstrapBundle; // expose for converted vanilla call sites
require("waypoints/lib/noframework.waypoints");

import "./highcharts_global_hack"; // Leave this near the top, it's mostly evil.
import "./accordions";
import "./admin";
import "./autocomplete";
import "./back_to_top";
import "./card_modals";
import "./companies";
import "./contact_messages";
import "./cookie_warning";
import "./countries";
import "./technologies";
import "./data_hub";
import "./data_hub_modal";
import "./devise/registrations";
import "./devise/sessions";
import "./disabled_links";
import "./downloads";
import "./free_demo_requests";
import "./ga";
import "./global_search_results";
import "./header";
import "./home_page_anonymous/fullpage.continuousHorizontal";
import "./home_page_anonymous";
import "../../../node_modules/fullpage.js/dist/jquery.fullpage.extensions.min.js";
import "./home_page";
import "./image_replace_links";
import "./modernizr";
import "./my_waterdata";
import "./nav";
import "./notifications";
import "./permalink_modal.js";
import "./popover_forms";
import "./print_links";
import "./relative_anchors";
import "./request_demo";
import "./resetable";
import "./screenshots";
import "./scrollspy";
import "./sections/related";
import "./slide_decks";
import "./sticky";
import "./toastr_options";
import "./tooltips";
import "./turbolinks_hack";
import "./whole_row_link_tables";
import "./support_pages";

import "./select2-custom/select2.full";
import d3Object from "d3";
import d3Tip from "d3-tip";
import noUiSlider from "nouislider";
import wNumb from "wnumb";
import toastr from "toastr";
import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import ReactApps from "./react/apps";
import "./demo_mode";
import leafletBuilder from "./maps";
import "./simple_expandable_table_row";
import "./collapsed_rows_table";
import "./pure_drawer";
import "./admin/forms";
import "./edit_own_account_form";
import "./require_all_if_any";
import makeSankey from "./sankey_charts";
import tariffSurveyHubPageRefresh from "./data_hub/tariff_surveys";
import customChartkick from "./chartkick_with_extras";
import "./analytics";
import "./export_to_csv";

import "slick-carousel";
import "./tinymce/plugins/insertvisualization/plugin";
import "./tinymce/plugins/texttooltip/plugin";
import Color from "color";
import debounce from "lodash/debounce";
import { cardResizedAdjustVisualization, updateCardStates } from "./cards";
import "./cookie_banner";

window.ColorTransform = Color;

window.tariffSurveyHubPageRefresh = tariffSurveyHubPageRefresh;
window.makeSankey = makeSankey;
window.leafletBuilder = leafletBuilder;

window.React = React;
window.ReactDOM = ReactDOM;
// React 19 removed the legacy `ReactDOM.render(element, container)` API (use `createRoot`). The app's
// own React code already migrated to `createRoot`, but STORED inserted-visualization inline scripts
// (PNG/SVG/HTML chart embeds authored under React 16, baked into saved card HTML) still call the
// global `ReactDOM.render` → `undefined` → throw → the card renders blank (~355
// SvgWrapper cards in the blast radius). Shim the legacy 2-arg signature onto `createRoot`, caching
// the root per container so a re-render doesn't re-`createRoot` (which React 19 warns on).
if (typeof ReactDOM.render !== "function") {
  window.ReactDOM.render = function (element, container, callback) {
    if (!container) { return null; }
    let root = container.__wdReactRoot;
    if (!root) { root = createRoot(container); container.__wdReactRoot = root; }
    root.render(element);
    if (typeof callback === "function") { setTimeout(callback, 0); }
    return null;
  };
}
window.reactAppList = ReactApps;

window.toastr = toastr;

window.noUiSlider = noUiSlider;
window.wNumb = wNumb;

window.updateCardStates = updateCardStates;

const $ = window.$; // This should get set in highcharts_global_hack.

// Add case-insensitive contains to jQuery
$.expr[":"].caseless_contains = $.expr.createPseudo(function(arg) {
  return function( elem ) {
    return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
  };
});

d3Object.tip = d3Tip;
// d3 v3 `d3.geo.*` compat for STORED chart-resource embeds (same stored-content
// removed-API class as the ReactDOM.render shim above, d3 edition):
// SimpleSvgWrapper inlines uploaded HTML blobs into the page, and blobs compiled against
// d3 v3 call `d3.geo.albersUsa()/.geo.path()` — v4+ flattened these to `d3.geoAlbersUsa/
// geoPath`, so the embed throws at mount and its react root stays empty
// (card 406096→385051 "InteractiveMap"; also the /markets/countries/united-states console
// TypeError). Sweep of all 375 local chart-resource files: albersUsa + path are the ONLY
// v3 `d3.geo.*` members referenced (charts 358564, 131301).
// `path` is NOT mapped straight to geoPath: v4+ rewrote spherical clipping, and a
// reversed-winding polygon that rendered fine under v3 now paints as its COMPLEMENT
// (the blob's Virginia covered the whole viewport). Wrapping the projection in a
// planar geoTransform bypasses spherical clipping — winding-agnostic, matching what
// these v3-era blobs actually rendered.
d3Object.geo = d3Object.geo || {
  albersUsa: d3Object.geoAlbersUsa,
  path: function () {
    const path = d3Object.geoPath();
    const setProjection = path.projection;
    // v3 returned null for empty geometries; the planar transform can emit a bare
    // "Z" (all points projected away, e.g. Puerto Rico under albersUsa' 48-state
    // inset-less blob data), which SVG rejects noisily. Normalize to null.
    const wrapped = function (obj) {
      const s = path(obj);
      return s && /^[Mm]/.test(s) ? s : null;
    };
    wrapped.projection = function (proj) {
      if (!arguments.length) { return setProjection(); }
      setProjection(proj == null ? null : d3Object.geoTransform({
        point(x, y) {
          const p = proj([x, y]);
          if (p) { this.stream.point(p[0], p[1]); }
        }
      }));
      return wrapped;
    };
    return wrapped;
  }
};
window.d3 = d3Object;

window.preloader = new Preloader();

window.Chartkick = customChartkick;

window.AirbrakeClient = AirbrakeClient;
window.isRecaptchaAirbrakeNoise = isRecaptchaAirbrakeNoise;

window.triggerEdtInit = debounce(function () { $(document).trigger("effective-datatables:initialize"); }, 100);

let delayCounter = 0;
window.delayedVisualizationRender = function (element, html, isOctopusChart, renderTargetSelector) {
  let waypoint, $element;
  if (element) {
    $element = $(element);

    // The render target is passed as an id selector ("#<uid>"). resizeText (cards.js) clones
    // an unresolved deferred card's `.content` -> `.always-full-content` on `turbolinks:load`,
    // duplicating that id, so at render time there can be MORE THAN ONE element carrying it.
    // jQuery's selector engine takes a getElementById fast path for a bare "#id" selector and
    // returns only the FIRST match even when the id is duplicated — so an id-selector find misses
    // the clone and its spinner never resolves. Rewrite "#<uid>" as the attribute selector
    // `[id="<uid>"]`, which goes through querySelectorAll and matches EVERY copy.
    const targetSelector = (typeof renderTargetSelector === "string" && renderTargetSelector.charAt(0) === "#")
      ? "[id=\"" + renderTargetSelector.slice(1).replace(/"/g, "\\\"") + "\"]"
      : renderTargetSelector;

    const renderAsync = async function() {
      // Re-resolve the render target(s) at render time, NOT at call time, and iterate EVERY
      // current copy (original + any resizeText clone). The per-element waypoint-triggered guard
      // keeps each injection idempotent across the setTimeout + waypoint invocations.
      let rendered = false;
      $element.find(targetSelector).each(function () {
        const $target = $(this);
        if (!$target.data("waypoint-triggered")) {
          $target.data("waypoint-triggered", true);
          $target.removeClass("min-height-400");
          $target.html(html);
          rendered = true;
        }
      });
      if (rendered) { window.triggerEdtInit(); }
    };
    waypoint = new Waypoint({
      element: element,
      offset: "bottom-in-view",
      enabled: false,
      // continuous: false,
      handler: renderAsync
    });
    setTimeout(function () {
      if (waypoint.callback) {
        waypoint.callback();
      }

      const card = $element.closest(".card")[0];
      if (card) {
        cardResizedAdjustVisualization(null, card);
        card.dispatchEvent(new Event("wd:card-ready"));
      }
    }, 100 + delayCounter * 50);
    delayCounter = delayCounter + 1;
  }

  if (isOctopusChart) {
    var $octoChart;
    var waitForOctoChart = setInterval(function () {
      $octoChart = $(".octopus-charts");
      if ($octoChart.length) {
        // Look in tooltips.js for triggered function
        window.dispatchEvent(new CustomEvent("octoChartLoaded"));
        clearInterval(waitForOctoChart);
      }
    }, 50);
  }
};

// Ensure garbage collection happens for preloaded images
$(document).on("turbolinks:load", function () {
  if (window.preloader && window.preloader.clear) {
    window.preloader.clear();
  }

  $(".slick-container").slick({
    infinite: false,
    dots: true,
    speed: 400,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    centerPadding: "10px",
  });
});
